import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Drawer from '@material-ui/core/Drawer';
// components
import CustomButton from './../Forms/CustomButton/CustomButton';
// css
import './CustomDrawer.scss';

const CustomDrawer = ({ side, drawerOpen, toggleDrawer, title, children, confirm, disabled }) => (
    <Drawer className="CustomDrawer" 
        anchor={side} 
        open={drawerOpen} 
        onClose={()=>toggleDrawer(false)}
        PaperProps={{
            classes:{
                root:'drawer'
            }
        }}
    >
        <form 
            onSubmit={(e) => {
                e.preventDefault();
                confirm();
                toggleDrawer(false);
            }}
        >
            <div className="drawer-heading">
                <div className="title">{title}</div>
                <div className="action-buttons">
                    <CustomButton
                        iconOnly
                        iconName='cross'
                        name= "cancel"
                        onClick={()=>toggleDrawer(false)}
                    />
                    <CustomButton
                        iconOnly
                        iconName='tick'
                        name={title}
                        type="submit"
                    />
                </div>
            </div>
            <div className="drawer-content">
                {children}
            </div>
        </form>
    </Drawer>
);

CustomDrawer.propTypes = {
    side: PropTypes.string,
    drawerOpen: PropTypes.bool,
    toggleDrawer: PropTypes.func,
    children: PropTypes.instanceOf(Object),
    title: PropTypes.string,
    disabled: PropTypes.bool,
    confirm: PropTypes.func
};

CustomDrawer.defaultProps = {
    side: 'right',
    drawerOpen: false,
    toggleDrawer: () => {},
    children: {},
    title: '',
    disabled: false,
    confirm: () => {}
};

export default CustomDrawer;


// WEBPACK FOOTER //
// ./common/CustomDrawer/CustomDrawer.js